export default __webpack_public_path__ + "static/rudimentary-mtg-cube-power-level-c0b46c6f1225feea5960d2a5b72d1cb2.png";